var exports = {
  "p": "x2b2fbebb--4dad95--list",
  "A": "x2b2fbebb--4dad95--item",
};

module.exports = exports;
